<div 
  [class]="containerClasses()"
  [innerHTML]="sanitizedContent()">
</div>